import { defineMessages } from 'react-intl';

const notificationMessages = defineMessages({
    ariaLabelDismiss: {
        id: 'notifications.notificationMessages.dismissAction',
        description: 'aria-label for dismissing an application notification - not user visible',
        defaultMessage: 'dismiss notification'
    },
    undoRemoveLinkText: {
        id: 'notifications.notificationMessages.undoRemoveLinkText',
        description: 'Visible link text in an application notification to undo the removal of an item from the cart',
        defaultMessage: 'Undo'
    },
    
    undoRemoveContent: {
        id: 'notifications.notificationMessages.undoRemoveContent',
        description: 'Message shown in an application notification when removing an item from the cart',
        defaultMessage: 'You removed {quantity} {denomination} Gift {quantity, plural, one {Card} other {Cards}} for {recipientName}'
    },
    undoRemoveContentSelfBuy: {
        id: 'notifications.notificationMessages.undoRemoveContentSelfBuy',
        description: 'Message shown in an application notification when removing an item from the cart which the purchaser is buying for themself',
        defaultMessage: 'You removed {quantity} {denomination} Gift {quantity, plural, one {Card} other {Cards}} for yourself'
    }
});

export default notificationMessages;
